<div class="td-wb-step">
  @if (isLinear()) {
    <button class="td-wb-step__button"
            type="button"
            [disabled]="!isSelectable()"
            [attr.aria-pressed]="isActive()"
            [attr.aria-disabled]="!isSelectable()"
            [attr.aria-labelledby]="getStepTitleId()"
            (click)="onSelect()">
    <span class="td-wb-step__label"
          [class.td-wb-step__label--active]="isActive()"
          [class.td-wb-step__label--complete]="isComplete()">
        <span class="td-wb-step__label-content"
              [innerText]="getLabel()"></span>
        <span class="td-wb-step__tick"></span>
    </span>
    </button>
  }
  @if (!isLinear() && isActive()) {
    <span [innerText]="'tdWb.steps.CURRENT_STEP_ACCESSIBLE_LABEL' | tdWbTranslate: {
      currentStep: getLabel(),
      totalSteps: getStepsCount()
       }">
  </span>
  }
  <ng-content />
</div>
